// Utils
import { isLocationCanvas } from '../../../common/elements/utils/elementLocationUtils';

// Constants
import { IN_LIST_MODE } from '../../../common/columns/columnConstants';
import { isPhone } from '../../utils/services/browser';

export const getShowQuickLineTool = ({ isSingleSelected, element, inList, isEditable }) =>
    isSingleSelected && (isLocationCanvas(element) || inList === IN_LIST_MODE.IN_LIST) && isEditable && !isPhone();
